import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative w-full flex flex-row items-center" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-800 text-sm ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col py-2 px-3 relative w-full", _ctx.tclass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createElementVNode("input", _mergeProps({
          class: ["p-2 border rounded mr-2", { 'border-red-800': _ctx.error && _ctx.error.length > 0 }],
          type: "checkbox",
          checked: _ctx.value,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, _ctx.$attrs), null, 16, _hoisted_2),
        _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
      ])
    ]),
    (_ctx.error && _ctx.error.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}